'use strict';

/*
  Page component that invokes Plaid and initiates Plaid Iframe.
*/
function LoanApplicationConnectToBankService() {
  var _this = this;

  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController, _BankController];

  this.init = function () {
    _this._super();
  };

  this.initAllReady = function () {
    _this._super();

    if (!_this._loanApplications[0]) {
      return;
    }

    // Update PlaidErrorHandler configs
    _this.updateErrorConfigs({
      initErrorPage: false
    });

    _this._loanApplicationBankId = _this._loanApplications[0].getBankId();
    _this._loanApplicationModel = _this._loanApplications[0].getModelPath();
    _this.analytics.forcePushEvent('virtual-page-view');
    _this.analytics.forcePushEvent('mogo-money-status', null, _this);
    _this._createBankAccount();
  };

  this.initPage = function () {};

  this.destroy = function () {
    _this._super();
  };

  this._createBankAccount = function () {
    if (_this._loanApplicationBankId) {
      var config = {};
      // map the errors that we want the Iframe to close on
      config.errorMap = {
        INSTITUTION_DOWN: 'TRY_AGAIN_LATER',
        INSTITUTION_NOT_RESPONDING: 'TRY_AGAIN_LATER',
        INSTITUTION_NOT_AVAILABLE: 'ACTION_TRY_AGAIN_LATER',
        INSTITUTION_NO_LONGER_SUPPORTED: 'NOT_SUPPORTED',
        ITEM_NOT_SUPPORTED: 'NOT_SUPPORTED',
        MFA_NOT_SUPPORTED: 'NOT_SUPPORTED',
        USER_SETUP_REQUIRED: 'USER_ACTION_REQUIRED',
        INVALID_UPDATED_USERNAME: 'USER_ACTION_REQUIRED',
        ITEM_LOCKED: 'USER_ACTION_REQUIRED',
        NO_ACCOUNTS: 'NO_ACCOUNTS',
        INVALID_PUBLIC_TOKEN: 'UNEXPECTED_ERROR',
        RATE_LIMIT: 'UNEXPECTED_ERROR',
        ITEM_NO_ERROR: 'ITEM_NO_ERROR'
      };

      _this.createBankAccount(null, function (newAcct) {
        _this._removeProgressLoader();
        // Bank Controller Method
        newAcct.linkAccount(function (bk) {
          _this._associateProduct(bk);
        }, _this._onCreateBankFailure.bind(_this), config);
      });
    }
  };

  this._associateProduct = function (acctObj, callbacks) {
    // At this point, we should have created and linked to a bank service
    // Associate the product:
    // product_type: 'loan'
    // product_id: 'the application id
    var payLoad = {};
    payLoad.product_type = BankAccount.productType.loan;

    var options = {};
    options.product_id = this._loanApplications[0].getLoanApplicationId();

    acctObj.associateWithProduct(payLoad.product_type, this._onAssociateSuccess.bind(this), this._bankStatusCheck.bind(this), options // pass product ID to associate the product
    );
  };

  /*
    on user completing plaid flow, when allow cta is accepted on the Plaid Iframe.
  */
  this._onAssociateSuccess = function () {
    var _this2 = this;

    this._attachProgressLoader();

    // Update Loan Application Bank Account on success
    // Expect bank_account_id and rellinks for kicking of ABS
    this.presenter.updateModel(this._loanApplicationModel, null, function () {
      _this2._history.goToUrl(_this2.paths.loans.application_flow_retrieve_bank);
    });
    // Go to Load animation view to start verification process
  };

  /*
    onExitClose() from Plaid Iframe.
    Callback for When user exits or plaid return errors.
     All Errors in which we determine to have a Custom UI(not handled by plaid) previously
    will lead the user down the path of DLT if bank is supported.
     Member is allowed to re-try (both part of errorCode user_action_required).
    - Invalid Credentials
    - Invalid MFA errors.
  */
  this._onCreateBankFailure = function (data) {
    var retryCodes = ['INVALID_MFA', 'INVALID_CREDENTIALS'];

    // 3 scenarios: unexpected http errors, voluntarily close, retry codes
    if (!data.errors && (!data.errorType && !data.errorCode || data.errorCode && retryCodes.includes(data.errorCode))) {
      // Go back to connect bank && push analytic events
      _this.analytics.pushEvent('generic-member-navigation', {
        memberNavigation: ['Money-ABS-Cancel-Navigation-Component']
      });
      // Allow user to retry
      _this._history.goToUrl(_this.paths.loans.application_flow_connect_bank);
    } else {
      _this._bankStatusCheck();
    }
  };

  this._bankStatusCheck = function () {
    // BankStatusCheck from Bank Account class returns 1 of the three below
    var onBankStatusCheckCallBack = {};
    onBankStatusCheckCallBack.onStatusNotSupported = this._onNotSupportedCallback.bind(this);
    onBankStatusCheckCallBack.onStatusOnline = this._onSupportedCallback.bind(this);
    onBankStatusCheckCallBack.onStatusOffline = this._onSupportedCallback.bind(this);

    this.bankPlaidStatusCheck(this._loanApplicationBankId, onBankStatusCheckCallBack);
  };

  this._removeProgressLoader = function () {
    // Progress Loader
    _this._$loanApplicationFlowLoader = $('.js--progress-loader');
    _this._$loanApplicationBody = $('.js--loan-application-body-content');

    // Hide page loader
    _this._$loanApplicationFlowLoader.addClass('hide');
    _this._$loanApplicationBody.removeClass('hide');
  };

  this._attachProgressLoader = function () {
    // Progress Loader
    _this._$loanApplicationFlowLoader = $('.js--progress-loader');
    _this._$loanApplicationBody = $('.js--loan-application-body-content');

    // Hide page loader
    _this._$loanApplicationFlowLoader.removeClass('hide');
    _this._$loanApplicationBody.addClass('hide');
  };

  this._onNotSupportedCallback = function () {
    // Update ABS_status to `not_supported` to notify BE/CRM
    var payLoad = {};
    payLoad.abs_status = 'not_supported';
    this._loanApplications[0].updateBankStatus(payLoad, {
      success: function (data, request) {
        // Go to Plaid not supported route
        $('#LoanApplicationTray').mogo()._loanAppSetStepComplete();
        this._history.goToUrl(this.paths.loans.application_flow_complete_error);
      }.bind(this),
      failure: this._onBankUpdateStatusFailure.bind(this)
    });
  };

  this._onSupportedCallback = function () {
    var payLoad = {};
    payLoad.abs_status = 'link_failure';
    this._loanApplications[0].updateBankStatus(payLoad, {
      success: function (data, request) {
        // Go to link fail complete view
        $('#LoanApplicationTray').mogo()._loanAppSetStepComplete();
        this._history.goToUrl(this.paths.loans.application_flow_complete_error);
      }.bind(this),
      failure: this._onBankUpdateStatusFailure.bind(this)
    });
  };

  this._onBankUpdateStatusFailure = function (data, response, request) {
    if (this.isGeneralConnectionIssue(data, response)) {
      if (this._errorInitialized === false) {
        this._errorInitialized = true;

        this.invokeConnectionIssuePage(request, {
          productLabel: 'Money'
        }, null, {
          retryRequest: true
        });
      }
    } else {
      $('#Notification').mogo().create({
        type: 'custom',
        msg: '<h2><span class="icon--warning"/>Oh no...</h2>' + "We're having some technical issues. Please try again. If the problem persists, try us again in a few minutes.",
        customClass: 'loan-application-notification--warning',
        notificationDescriber: 'error'
      });

      $.each(data.errors, function (index, element) {
        console.warn('key: ' + element.key + ', ' + ('msg: ' + element.msg));
      });
    }
  };
}